import { Injectable } from "@angular/core";
import { ConfigService, OAuthService, AppUppyFile, AppUploadResult, AppUppy } from "common";

@Injectable()
export class ProgressBarDialogService {
  
  generateEndpointCallback: (meta: any) => string;

  constructor(
    private configService: ConfigService,
    private authService: OAuthService
    ) {}
    
  setEndpointGenerator(generateEndpoint: (meta: any) => string) {
    this.generateEndpointCallback = generateEndpoint;
  }
  
  public prepairUppyAndStartUpload(
    uppy: AppUppy,
    files: AppUppyFile[]
  ): Promise<AppUploadResult> {
    this.clearAllFiles(uppy);
    this.setFilesToUppy(uppy, files);
    this.setUppyFilesEndpoints(uppy);

    return uppy.upload() as Promise<AppUploadResult>;
  }

  private clearAllFiles(uppy: AppUppy) {
    const files = uppy.getFiles();
    files.forEach((file) => {
      uppy.removeFile(file.id);
    });
  }

  private setFilesToUppy(uppy: AppUppy, filesToUpload: AppUppyFile[]) {
    filesToUpload.forEach((checkoutFileToUpload) => {
      checkoutFileToUpload.name = this.getFileNameWithCopiesCount(
        uppy,
        checkoutFileToUpload.name
      );
      try {
        uppy.addFile(checkoutFileToUpload as any);
      }
      catch {
        console.info('Upload files - adding trouble');
      }
    });
  }

  private setUppyFilesEndpoints(uppy: AppUppy): void {
    const files = uppy.getFiles();

    files.forEach((uppyFile) => {
      uppy.setFileMeta(uppyFile.id, {
        ...uppyFile.meta,
        uploadEndpoint: this.generateEndpoint(uppyFile.meta),
        uploadAuthToken: this.authService.accessToken,
      } as any);
    });
  }

  private getFileNameWithCopiesCount(uppy: AppUppy, filename: string): string {
    const filesWithSameName = uppy
      .getFiles()
      .filter((f) => f.name.startsWith(this.getFilename(filename)));
    if (filesWithSameName && filesWithSameName.length > 0) {
      const dotIndex = filename.lastIndexOf(".");
      if (dotIndex === -1) {
        filename = `${filename}_${filesWithSameName.length}`;
      } else {
        filename = `${filename.substring(0, dotIndex)}_${
          filesWithSameName.length
        }${filename.substring(dotIndex)}`;
      }
    }
    return filename;
  }

  private getFilename(filename: string): string {
    const dotIndex = filename.lastIndexOf(".");
    if (dotIndex === -1) {
      return filename;
    } else {
      return `${filename.substring(0, dotIndex)}`;
    }
  }

  private generateEndpoint(meta: any): string {
    if (this.generateEndpointCallback) {
      return this.generateEndpointCallback(meta);
    }
    else {
      return `${this.configService.environment.applications.url}/api/checkout-requirements/${meta.checkoutRequirementId}/files/${meta.category}`;
    }
  }
}
